import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material'

const WriteOffConfirmation = ({ open, onClose, varianceAmount, onAdjustAmount, onAddAllocation }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Typography variant="h6" component="div">
                    Variance Confirmation
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ py: 1 }}>
                    <Typography variant="h5">
                        Variance is <strong>{varianceAmount?.toFixed(2) || '-'}</strong>, please adjust the Receivable amount.
                    </Typography>
                        <Typography variant="caption" color="warning.dark">
                            *The transaction will be completed as the variance is less than 1$
                        </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onAdjustAmount}
                    variant="outlined"
                    color="secondary"
                    sx={{ mr: 1 }}
                >
                    Adjust Amount
                </Button>
                <Button
                    onClick={onAddAllocation}
                    variant="contained"
                    color="primary"
                >
                    Add Allocation
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default WriteOffConfirmation